import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ComponentInteractionService {
  private buildingDropdownSource = new Subject<any>();
  getBuildingDropdown = this.buildingDropdownSource.asObservable();

  private buildingDropdownChange = new Subject<any>();
  getBuildingDropdownChangeVal = this.buildingDropdownChange.asObservable();

  private siteData = new Subject<any>();   /////getBranchDetails data
  getSiteData = this.siteData.asObservable();

  private serviceCallJson = new Subject<any>();   /////dadqbox data
  getserviceCallJson = this.serviceCallJson.asObservable();

  private filterJson = new BehaviorSubject<any>('');   /////Filter data
  getFilterJson = this.filterJson.asObservable();

  private isFilterOpen = new Subject<any>();   /////Filter data
  getIsFilterOpen = this.isFilterOpen.asObservable();

  // private appliedFilterJson = new Subject<any>();   /////Filter data
  // getAppliedFilterJson = this.appliedFilterJson.asObservable();

  private themeOption = new Subject<any>();   /////Theme data
  getThemeOption = this.themeOption.asObservable();

  private submenu = new Subject<any>();   /////Theme data
  getSubmenu = this.submenu.asObservable();

  private assetType = new Subject<any>();   /////assetType data
  getAssetType = this.assetType.asObservable();

  constructor() { }

  setAssetType(data){
    this.assetType.next(data);
  }
  
  //Dropdown data source service
  passBuildingDropdownData(data) {
    this.buildingDropdownSource.next(data)
  }

  //Dropdown change value service
  passBuildingDropdownChangeData(data) {
    this.buildingDropdownChange.next(data)
  }

  setSiteData(data) {
    this.siteData.next(data)
  }

  setServiceCallJson(data) {
    this.serviceCallJson.next(data)
  }

  setFilterJson(data) {
    this.filterJson.next(data)
  }

  setIsFilterOpen(data){
    this.isFilterOpen.next(data);
  }
  // setAppliedFilterJson(data) {
  //   this.appliedFilterJson.next(data)
  // }
  
  setThemeOption(data){
    this.themeOption.next(data);
  }

  setSubmenu(data){
    this.submenu.next(data);
  }

}
